import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { ECommonCountries } from 'enums/commonCountries';
import { ceskePscRegExp } from 'enums/regExp';

export const pscValidation = (getValueFrom: string) => [
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ getFieldValue }: any) => ({
        validator(_rule: RuleObject, value: string) {
            if (!getFieldValue(getValueFrom)) return Promise.resolve();
            if (
                getFieldValue(getValueFrom) === ECommonCountries.CZ ||
                getFieldValue(getValueFrom) === ECommonCountries.SK
            ) {
                if (!value || ceskePscRegExp.test(value)) return Promise.resolve();
                return Promise.reject(<TranslateText>PSC_ERROR</TranslateText>);
            }
            return Promise.resolve();
        }
    })
];

export default pscValidation;
